
import {
  populateImagesInSection,
  rewriteContentInSection
} from "@/lib/singularity/sections";
import { aiJobController } from "@/types/singularity/ai-jobs";
import { TreeNode } from "@/types/tree";
import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component({
  components: {}
})
export default class SectionWriter extends Vue {
  sectionId: TreeNode["id"] = -1;

  async writeSection() {
    aiJobController.addJob(
      async abortController => {
        await rewriteContentInSection(this.sectionId, abortController);
      },
      "rewrite triggered manually by sectionwriter.vue",
      this.sectionId
    );
  }

  async populateImages() {
    aiJobController.addJob(
      async abortController => {
        await populateImagesInSection(this.sectionId, abortController);
      },
      "populate images triggered manually by sectionwriter.vue",
      this.sectionId
    );
  }
}
